import React from 'react';
import { Global } from '@emotion/react';
import { Box, Stack, SwipeableDrawer } from '@mui/material';
import { styled } from '@mui/material/styles';

import { DRAWER_BLEEDING as drawerBleeding } from '../../../consts';

const Puller = styled(Box)(({ theme }) => ({
  width: 72,
  height: 36,
  backgroundColor: theme.palette.background.paper,
  borderRadius: '20px 20px 0 0',
  cursor: 'grab',
  display: 'flex',
  justifyContent: 'center',
  position: 'absolute',
  top: -20,
  left: '50%',
  transform: 'translateX(-50%)',
  paddingTop: 10,
  '&::after': {
    content: "''",
    width: 36,
    height: 5,
    backgroundColor: theme.palette.divider,
    borderRadius: 3,
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

const StyledSwipeableDrawer = styled(SwipeableDrawer)({
  '& .MuiDrawer-paper': {
    backgroundImage: 'none',
  },
});

const modalProps = { slotProps: { backdrop: { invisible: true } } };

const MobileDrawer = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const iOS =
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <>
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: `calc(50% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />
      <StyledSwipeableDrawer
        ModalProps={modalProps}
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableBackdropTransition={true}
        disableDiscovery={iOS}
        anchor="bottom"
        swipeAreaWidth={56}
        disableSwipeToOpen={false}
      >
        <StyledBox
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            height: drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: 'visible',
            right: 0,
            left: 0,
          }}
        >
          <Puller />
        </StyledBox>
        <Stack sx={{ overflowY: 'auto' }}>{children}</Stack>
      </StyledSwipeableDrawer>
    </>
  );
};

export { MobileDrawer };
